import { makeStyles } from '@material-ui/core/styles'

import UserAvatar from './user-avatar'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'flex-start',
  },
  bubble: {
    backgroundColor: 'var(--ds-bg-surface, #fff)',
    border: '1px solid var(--ds-border-default, #d7dae4)',
    borderRadius: 16,
    padding: theme.spacing(2),
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: '999px',
    backgroundColor: 'var(--ds-fg-tertiary, #8c92a5)',
    animation: '$typing 1.2s infinite ease-in-out',
  },
  dot2: {
    animationDelay: '0.2s',
  },
  dot3: {
    animationDelay: '0.4s',
  },
  '@keyframes typing': {
    '0%, 80%, 100%': {
      opacity: 0.25,
      transform: 'translateY(0)',
    },
    '40%': {
      opacity: 1,
      transform: 'translateY(-2px)',
    },
  },
}))

const TypingIndicator = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <UserAvatar type="assistant" />
      <div className={classes.bubble}>
        <span className={classes.dot} />
        <span className={`${classes.dot} ${classes.dot2}`} />
        <span className={`${classes.dot} ${classes.dot3}`} />
      </div>
    </div>
  )
}

export default TypingIndicator
